import React from "react";

/** 차트/위젯 카드 내부용 로딩 (레이아웃 유지, absolute 오버레이) */
function ChartLoadingOverlay() {
    return (
        <div
            className="absolute inset-0 z-10 flex items-center justify-center bg-white/70"
            aria-busy="true"
            aria-label="데이터를 불러오는 중"
        >
            <div
                className="h-10 w-10 animate-spin rounded-full border-2 border-[#e8e8e8] border-t-[#070707]"
                role="presentation"
            />
        </div>
    );
}

export default ChartLoadingOverlay;
